import { render, staticRenderFns } from "./ResponseEditor.vue?vue&type=template&id=f561ac86&scoped=true&v-if=this.user.loggedIn"
import script from "./ResponseEditor.vue?vue&type=script&lang=js"
export * from "./ResponseEditor.vue?vue&type=script&lang=js"
import style0 from "./ResponseEditor.vue?vue&type=style&index=0&id=f561ac86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f561ac86",
  null
  
)

export default component.exports